import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { cn } from '../../../../utils/utils';

export interface IStep {
  stepName: string;
  stepQuery: string;
}

/** Step header driven by the `?title=` query param (contacts, USSD flows). */
@Component({
  selector: 'alternative-stepper',
  standalone: true,
  imports: [],
  templateUrl: './alternative-stepper.component.html',
  styleUrls: ['./alternative-stepper.component.css', '../stepper/stepper-track.css'],
})
export class AlternativeStepperComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  constructor(private route: ActivatedRoute) {}

  searchQuery!: string;
  currentIndex: number = 0;
  currentComponent!: IStep;

  @Input() steps!: IStep[];
  /**this is used if you don't want to use the ng-content of the alternative stepper */
  @Input() noContent: boolean = false;
  @Input() contentClass: string = '';

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.searchQuery = params['title']; // Access a specific parameter

      if (!params['title']) {
        this.currentComponent = this.steps[0];
      }
      this.steps.forEach((el, idx) => {
        if (this.searchQuery == el.stepQuery) {
          this.currentIndex = idx;
        }
      });
    });
  }

  stateOf(index: number): 'done' | 'current' | 'todo' {
    if (index < this.currentIndex) return 'done';
    return index === this.currentIndex ? 'current' : 'todo';
  }

  merge = cn;
}
